<p-toast></p-toast>
<div>
    <p-card styleClass="p-card-shadow">
        <!-- <h5 class="mt-0">Farmer Application Details</h5> -->
        <div class="card dashboardTable">
            <p-toolbar styleClass="mb-4">
                <ng-template pTemplate="left">
                </ng-template>
                <ng-template pTemplate="right">
                    <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT' | translate}}"
                        icon="pi pi-upload" class="p-button-help"></button>
                        <p-menu #menu [popup]="true" [model]="menuItems"></p-menu>
                    <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}" icon="pi pi-refresh"
                        class="p-button-info ml-3"></button>
                </ng-template>

            </p-toolbar>

            <p-table #farmerShareToVendorPFMSReportTable [value]="farmerShareToVendorPFMSReportModel" [rows]="10"
                [paginator]="true"
                [globalFilterFields]="['Srno','Lot_No', 'dateofExport','Sum_of_PFMS_Export', 'TargetDays', 'PendingCompletedDays', 'NoOfTimesExported', 'Sum_of_Successfull_Records', 'Sum_of_Pending_Records', 'Sum_of_Failed_Records', 'Sum_of_Bank_Transfer_Successfull_Records', 'block', 'district', 'No_of_Record', 'remarks', 'status','Status_Ar', 'village', 'lotNoForSorting', 'FinYear', 'No_of_Pending_Records', 'No_of_Failed_Records', 'No_of_Successfull_Records', 'No_of_Bank_Transfer_Successfull_Records']"
                responsiveLayout="scroll" [(selection)]="selectedBankAccounts" [rowHover]="true" dataKey="id"
                currentPageReportTemplate="{{'SHOWING' | translate}} {first} {{'TO' | translate}} {last} {{'OF' | translate}} {totalRecords} {{'ENTRIES' | translate}}"
                [showCurrentPageReport]="true" sortField="lotNoForSorting" [sortOrder]="1" [loading]="loading" >
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">{{'FARMER_SHARE_TO_VENDOR_HEADER'| translate}}</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="farmerShareToVendorPFMSReportTable.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH' | translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <!-- <th pSortableColumn="Srno">{{'S_NO'| translate}}
                            <p-columnFilter type="text" field="Srno" display="menu"></p-columnFilter>
                            <p-sortIcon field="Srno"></p-sortIcon>
                        </th> -->
                        <th pSortableColumn="lotNoForSorting">{{'FILE_NO'| translate}}
                            <p-columnFilter type="text" field="Lot_No" display="menu"></p-columnFilter>
                            <p-sortIcon field="lotNoForSorting"></p-sortIcon>
                        </th>
                        <th pSortableColumn="dateofExport">{{'DATE_OF_EXPORT'| translate}}
                            <p-columnFilter type="text" field="dateofExport" display="menu"></p-columnFilter>
                            <p-sortIcon field="dateofExport"></p-sortIcon>
                        </th>
                        <th pSortableColumn="No_of_Record">{{'NO_OF_RECORDS'| translate}}
                            <p-columnFilter type="text" field="No_of_Record" display="menu"></p-columnFilter>
                            <p-sortIcon field="No_of_Record"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Sum_of_PFMS_Export">{{'SUM_OF_PFMS_EXPORT'| translate}}
                            <p-columnFilter type="text" field="Sum_of_PFMS_Export" display="menu"></p-columnFilter>
                            <p-sortIcon field="Sum_of_PFMS_Export"></p-sortIcon>
                        </th>
                        <th pSortableColumn="TargetDays">{{'TARGET_DAYS' | translate}}
                            <p-columnFilter type="text" field="TargetDays" display="menu"></p-columnFilter>
                            <p-sortIcon field="TargetDays"></p-sortIcon>
                        </th>
                        <th pSortableColumn="PendingCompletedDays">{{'PENDING_COMPLETED_DAYS' | translate}}
                            <p-columnFilter type="text" field="PendingCompletedDays" display="menu"></p-columnFilter>
                            <p-sortIcon field="PendingCompletedDays"></p-sortIcon>
                        </th>
                        <!-- <th pSortableColumn="NoOfTimesExported">{{'NO_OF_TIMES_EXPORTED' | translate}}
                            <p-columnFilter type="text" field="NoOfTimesExported" display="menu"></p-columnFilter>
                            <p-sortIcon field="NoOfTimesExported"></p-sortIcon>
                        </th> -->
                        <th pSortableColumn="No_of_Successfull_Records">{{'NO_OF_SUCCESSFULL_RECORDS'| translate}}
                            <p-columnFilter type="text" field="No_of_Successfull_Records" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="No_of_Successfull_Records"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Sum_of_Successfull_Records">{{'SUM_OF_SUCCESSFULL_RECORDS'| translate}}
                            <p-columnFilter type="text" field="Sum_of_Successfull_Records" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="Sum_of_Successfull_Records"></p-sortIcon>
                        </th>
                        <th pSortableColumn="NoOfPendingRecords">{{'NO_OF_PENDING_RECORDS'| translate}}
                            <p-columnFilter type="text" field="NoOfPendingRecords" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="NoOfPendingRecords"></p-sortIcon>
                        </th>
                        <th pSortableColumn="SumOfPendingRecords">{{'SUM_OF_PENDING_RECORDS'| translate}}
                            <p-columnFilter type="text" field="SumOfPendingRecords" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="SumOfPendingRecords"></p-sortIcon>
                        </th>
                        <th pSortableColumn="No_of_Failed_Records">{{'NO_OF_FAILED_RECORDS'| translate}}
                            <p-columnFilter type="text" field="No_of_Failed_Records" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="No_of_Failed_Records"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Sum_of_Failed_Records">{{'SUM_OF_FAILED_RECORDS'| translate}}
                            <p-columnFilter type="text" field="Sum_of_Failed_Records" display="menu"></p-columnFilter>
                            <p-sortIcon field="Sum_of_Failed_Records"></p-sortIcon>
                        </th>
                        <th pSortableColumn="No_of_Bank_Transfer_Successfull_Records">
                            {{'NO_OF_BANK_TRANSFER_SUCCESSFULL_RECORDS'| translate}}
                            <p-columnFilter type="text" field="No_of_Bank_Transfer_Successfull_Records" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="No_of_Bank_Transfer_Successfull_Records"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Sum_of_Bank_Transfer_Successfull_Records">
                            {{'SUM_OF_BANK_TRANSFER_SUCCESSFULL_RECORDS'| translate}}
                            <p-columnFilter type="text" field="Sum_of_Bank_Transfer_Successfull_Records" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="Sum_of_Bank_Transfer_Successfull_Records"></p-sortIcon>
                        </th>
                        <th pSortableColumn="FinYear">{{'FINANCIAL_YEAR'| translate}}
                            <p-columnFilter type="text" field="FinYear" display="menu"></p-columnFilter>
                            <p-sortIcon field="FinYear"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(product)}">
                        <!-- <td>{{product.Srno}}</td> -->
                        <td><button (click)="pmfsExport(product.Lot_No, '')" pButton pRipple type="button"
                                label="{{product.Lot_No}}" class="p-button-text"></button></td>
                        <td>{{product?.dateofExport}}</td>
                        <td>{{product?.No_of_Record}}</td>
                        <td>{{product?.Sum_of_PFMS_Export}}</td>
                        <td>{{product?.TargetDays}}</td>
                        <td>{{product?.PendingCompletedDays}}</td>
                        <!-- <td>{{product?.NoOfTimesExported}}</td> -->
                        <td>{{product?.No_of_Successfull_Records}}</td>
                        <td><button (click)="pmfsExport(product.Lot_No, 'S')" pButton pRipple type="button"
                            label="{{product?.Sum_of_Successfull_Records}}" class="p-button-text"></button></td>
                        <td>{{product?.NoOfPendingRecords}}</td>
                        <td><button (click)="pmfsExport(product.Lot_No, 'P')" pButton pRipple type="button"
                            label="{{product?.SumOfPendingRecords}}" class="p-button-text"></button></td>
                        <td>{{product?.No_of_Failed_Records}}</td>
                        <td><button (click)="pmfsExport(product.Lot_No, 'F')" pButton pRipple type="button"
                            label="{{product?.Sum_of_Failed_Records}}" class="p-button-text"></button></td>
                        <td>{{product?.No_of_Bank_Transfer_Successfull_Records}}</td>
                        <td>{{product?.Sum_of_Bank_Transfer_Successfull_Records}}</td>
                        <td>{{product?.FinYear}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="flex  justify-content-between flex-column ">
                        <p>{{'IN_TOTAL_THERE_ARE' | translate}} {{farmerShareToVendorPFMSReportModel ?
                            farmerShareToVendorPFMSReportModel.length : 0 }} {{'RECORDS_ADDED' | translate}}
                        </p>
                        <div class="flex  justify-content-between flex-column "> 
                            <div class="flex"><div style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'PENDING_THREE_OR_MORE_DAYS' | translate}}</div>
                            <div class="flex"><div style="background-color:#ffc966 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'PENDING_BY_ONE_OR_TWO_DAYS' | translate}}</div>
                            <div class="flex"><div style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'APPROVED_ON_TIME' | translate}}</div>
                        </div>
                    </div>
                </ng-template>
            </p-table>
        </div>
    </p-card>
</div>

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>

<p-dialog [(visible)]="addDialog" [modal]="true" [style]="{ width: '100%', height: '100%' }" [maximizable]="true"
    [draggable]="false" [resizable]="false" (onHide)="hideDialog()">
    <div class="mi-survey-container">
        <p-card styleClass="p-card-shadow">
            <div class="card">
                <div class="heading my-3">
                    <p>File No : {{ lotNo }}</p>
                </div>
                <p-table #miSurvey [value]="miSurveyData" [rows]="10" [paginator]="true" [globalFilterFields]="[
                    'Full_Name_in_Recognized_Official_Language',
                    'Full_Name_In_English',
                    'Caste_Description',
                    'GST_NO',
                    'Address_Line_1',
                    'Address_Line_2',
                    'Address_Line_3',
                    'District',
                    'State', 
                    'Country', 
                    'Vendor_Bank_Name', 
                    'Vendor_IFSC_Code',
                    'Vendor_Account_Number', 
                    'Vendor_Pan_Card_No', 
                    'Pincode', 
                    'Scheme_Specific_Id',
                    'Farmer_Share_To_Vendor',
                    'Remarks',
                    'ChallanNo',
                    'UTR',
                    'CreditedOnDateTime',
                    'Programme_Name',
                    'UserType',
                    'Applicant_type',
                    'MIArea',
                    'CAORemarks'
                    ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id"
                    currentPageReportTemplate="{{'SHOWING' | translate}} {first} {{'TO' | translate}} {last} {{'OF' | translate}} {totalRecords} {{'ENTRIES' | translate}}"
                    [showCurrentPageReport]="true" [loading]="loading1">
                    <ng-template pTemplate="caption">
                        <div class="flex align-items-center justify-content-between">
                            <h5 class="m-0">{{'FARMER_APPLICATION_MI_FARMER_SHARE' | translate}}</h5>
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text"
                                    (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                                    placeholder="{{'SEARCH' | translate}}" />
                            </span>
                        </div>
                    </ng-template>

                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="">{{'VIEW_APPLICATION' | translate}}</th>
                            <th pSortableColumn="Full_Name_In_English">{{'FULL_NAME_IN_ENGLISH' | translate}}
                                <p-columnFilter type="text" field="Full_Name_In_English"
                                    display="menu"></p-columnFilter>
                                <p-sortIcon field="Full_Name_In_English"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Full_Name_in_Recognized_Official_Language">
                                {{'FULL_NAME_IN_RECOGNIZED_OFFICIAL_LANGUAGE' | translate}}
                                <p-columnFilter type="text" field="Full_Name_in_Recognized_Official_Language"
                                    display="menu"></p-columnFilter>
                                <p-sortIcon field="Full_Name_in_Recognized_Official_Language"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Caste_Description">
                                {{'CASTE' | translate}}
                                <p-columnFilter type="text" field="Caste_Description"
                                    display="menu"></p-columnFilter>
                                <p-sortIcon field="Caste_Description"></p-sortIcon>
                            </th>
                            <th pSortableColumn="GST_NO">{{'GST_NO' | translate}}
                                <p-columnFilter type="text" field="GST_NO" display="menu"></p-columnFilter>
                                <p-sortIcon field="GST_NO"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Address_Line_1">{{'ADDRESSLINE1' | translate}}
                                <p-columnFilter type="text" field="Address_Line_1" display="menu"></p-columnFilter>
                                <p-sortIcon field="Address_Line_1"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Address_Line_2">{{'ADDRESSLINE2' | translate}}
                                <p-columnFilter type="text" field="Address_Line_2" display="menu"></p-columnFilter>
                                <p-sortIcon field="Address_Line_2"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Address_Line_3">{{'ADDRESSLINE3' | translate}}
                                <p-columnFilter type="text" field="Address_Line_3" display="menu"></p-columnFilter>
                                <p-sortIcon field="Address_Line_3"></p-sortIcon>
                            </th>
                            <th pSortableColumn="District">{{'DISTRICT' | translate}}
                                <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                                <p-sortIcon field="District"></p-sortIcon>
                            </th>
                            <th pSortableColumn="State">{{'STATE' | translate}}
                                <p-columnFilter type="text" field="State" display="menu"></p-columnFilter>
                                <p-sortIcon field="State"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Country">{{'COUNTRY' | translate}}
                                <p-columnFilter type="text" field="Country" display="menu"></p-columnFilter>
                                <p-sortIcon field="Country"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Vendor_Bank_Name">{{'VENDOR_BANK_NAME' | translate}}
                                <p-columnFilter type="text" field="Vendor_Bank_Name" display="menu"></p-columnFilter>
                                <p-sortIcon field="Vendor_Bank_Name"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Vendor_IFSC_Code">{{'VENDOR_IFSCCODE' | translate}}
                                <p-columnFilter type="text" field="Vendor_IFSC_Code" display="menu"></p-columnFilter>
                                <p-sortIcon field="Vendor_IFSC_Code"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Vendor_Account_Number">{{'VENDOR_ACCOUNT_NUMBER' | translate}}
                                <p-columnFilter type="text" field="Vendor_Account_Number" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="Vendor_Account_Number"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Vendor_Pan_Card_No">{{'VENDOR_PAN_CARD_NO' | translate}}
                                <p-columnFilter type="text" field="Vendor_Pan_Card_No" display="menu"></p-columnFilter>
                                <p-sortIcon field="Vendor_Pan_Card_No"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Pincode">{{'PINCODE' | translate}}
                                <p-columnFilter type="text" field="Pincode" display="menu"></p-columnFilter>
                                <p-sortIcon field="Pincode"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Scheme_Specific_Id">{{'SCHEME_SPECIFIC_ID' | translate}}
                                <p-columnFilter type="text" field="Scheme_Specific_Id" display="menu"></p-columnFilter>
                                <p-sortIcon field="Scheme_Specific_Id"></p-sortIcon>
                            </th>
                            <th pSortableColumn="ChallanNo">{{'CHALLAN_NO' | translate}}
                                <p-columnFilter type="text" field="ChallanNo" display="menu"></p-columnFilter>
                                <p-sortIcon field="ChallanNo"></p-sortIcon>
                            </th>
                            <th pSortableColumn="UTR">{{'UTR' | translate}}
                                <p-columnFilter type="text" field="UTR" display="menu"></p-columnFilter>
                                <p-sortIcon field="UTR"></p-sortIcon>
                            </th>
                            <th pSortableColumn="CreditedOnDateTime">{{'CREDITED_DATE' | translate}}
                                <p-columnFilter type="text" field="CreditedOnDateTime" display="menu"></p-columnFilter>
                                <p-sortIcon field="CreditedOnDateTime"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Farmer_Share_To_Vendor">{{'CHALLAN_AMOUNT_DEPOSITED' | translate}}
                                <p-columnFilter type="text" field="Farmer_Share_To_Vendor" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="Farmer_Share_To_Vendor"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Programme_Name">{{'PROGRAMME_NAME' | translate}}
                                <p-columnFilter type="text" field="Programme_Name" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="Programme_Name"></p-sortIcon>
                            </th>
                            <th pSortableColumn="UserType">{{'USER_TYPE' | translate}}
                                <p-columnFilter type="text" field="UserType" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="UserType"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Applicant_type">{{'APPLICATION_TYPE' | translate}}
                                <p-columnFilter type="text" field="Applicant_type" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="Applicant_type"></p-sortIcon>
                            </th>
                            <th pSortableColumn="MIArea">{{'MIAREA' | translate}}
                                <p-columnFilter type="text" field="MIArea" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="MIArea"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Remarks">{{'REMARKS' | translate}}
                                <p-columnFilter type="text" field="Remarks" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="Remarks"></p-sortIcon>
                            </th>
                            <th pSortableColumn="CAORemarks">{{'CAO_REMARKS' | translate}}
                                <p-columnFilter type="text" field="CAORemarks" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="CAORemarks"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product>
                        <tr>
                            <td>
                                <button pButton pRipple pTooltip="{{'VIEW_APPLICATION' | translate}}" icon="pi pi-file"
                                    class="p-button-rounded p-button-accent mr-1 btnSize"
                                    (click)="selectFarmerApplication(product)"></button>
                            </td>
                            <td>{{product.Full_Name_In_English}}</td>
                            <td>{{product.Full_Name_in_Recognized_Official_Language}}</td>
                            <td>{{product.Caste_Description}}</td>
                            <td>{{product.GST_NO}}</td>
                            <td>{{product.Address_Line_1}}</td>
                            <td>{{product.Address_Line_2}}</td>
                            <td>{{product.Address_Line_3}}</td>
                            <td>{{product.District}}</td>
                            <td>{{product.State}}</td>
                            <td>{{product.Country}}</td>
                            <td>{{product.Vendor_Bank_Name}}</td>
                            <td>{{product.Vendor_IFSC_Code}}</td>
                            <td>{{product.Vendor_Account_Number}}</td>
                            <td>{{product.Vendor_Pan_Card_No}}</td>
                            <td>{{product.Pincode}}</td>
                            <td>{{product.Scheme_Specific_Id}}</td>
                            <td>{{product.ChallanNo}}</td>
                            <td>{{product.UTR}}</td>
                            <td>{{product.CreditedOnDateTime | date:'mediumDate'}}</td>
                            <td>{{product.Farmer_Share_To_Vendor}}</td>
                            <td>{{product.Programme_Name}}</td>
                            <td>{{product.UserType}}</td>
                            <td>{{product.Applicant_type}}</td>
                            <td>{{product.MIArea}}</td>
                            <td>{{product.Remarks}}</td>
                            <td>{{product.CAORemarks}}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="flex align-items-center justify-content-between">
                            {{'IN_TOTAL_THERE_ARE' | translate}} {{miSurveyData ? miSurveyData?.length : 0 }}
                            {{'MI_FARMER_SHARE_TO_VENDOR_LOT_APPLICATIONS_ADDED' | translate}}
                        </div>
                    </ng-template>
                </p-table>
            </div>

            <div class="card certificate-container" *ngIf="miCertificateData">
                <p-card styleClass="p-card-shadow">
                    <!-- <h5 class="mt-0">Farmer Application Details</h5> -->
                    <div class="mt-2" id="printableArea">
                        <div class="print border bold" style="margin-top: 1px; text-align: center">
                            <div class="flex justify-content-center">
                                <img src="assets/activitiesImages/micada_new_logo.png" alt="footer sections" width="100" height="40"
                                    class="mr-2 mt-1">
                            </div>
                            <div class="mt-3 headings">
                                <strong>
                                    {{'SANCTION_LETTER_HEADER'| translate}}
                                </strong>
                                <br>
                                <strong>{{'HARYANA'| translate}} </strong><br>
                                <strong>
                                    {{'FINANCIAL_YEAR_2022'| translate}}
                                </strong>
                            </div>
                        </div>
                        <div class="container mx-2 mt-3">
                            <div class="header my-3 mx-5">
                                <div class="flex justify-content-between mx-5 my-3">
                                    <p>Lot no. <b>{{ lotNo }}</b></p>
                                    <p>Date the lot of print generated <b>{{ printGeneratedDate }}</b></p>
                                </div>
                            </div>
                            <div class="header my-3 mx-5">
                                <div class="flex justify-content-end mx-5 my-3">
                                    <p>Period date <b>{{ miCertificateData?.prevDate }}</b> to date <b>{{ miCertificateData?.currentDate }}</b></p>
                                </div>
                            </div>

                            <div class="header my-3 mx-5 text-justify">Total farmer share deposited till date <b>{{ miCertificateData?.currentDate }}</b>
                               total application <b>{{ miCertificateData?.totalChallanApp}}</b> Amount Rs. <b>{{ miCertificateData?.totalChallanAmount }}</b>.</div>
                            <div class="header my-3 mx-5 text-justify">
                                Detail this lot no. <b>{{ lotNo }}</b> total Application <b>{{ miCertificateData?.totalLotApp }}</b> Amount Rs. <b>{{ miCertificateData?.totalLotAmount }}</b> from date
                                <b>{{ miCertificateData?.prevDate }}</b> to date <b>{{ miCertificateData?.currentDate }}</b>.</div>
                            <div class="header my-3 mx-5 text-justify">
                                Payment for Farmer share done lot numbers,
                                <b>{{ miCertificateData?.ImportLot == null ? '___' : miCertificateData?.ImportLot }}</b> Amount Rs.<b>{{ miCertificateData?.ImportAmt == null ? '___' : miCertificateData?.ImportAmt }}</b> </div>


                            <div class="details mt-3">
                                <div class="flex justify-content-center bold mb-1">Certificate-1</div>
                                <div class="header my-3 mx-2 text-justify">The farmer share of <b>{{ miCertificateData?.totalLotApp }}</b> no. of
                                    applications for amount Rs. <b>{{ miCertificateData?.totalLotAmount }}</b> has been received as per the portal report. This Lot is submitted for
                                    further processing as per the next process of verification and payment approval.
                                </div>
                                <div class="flex justify-content-end mx-5 mt-5 pt-5">
                                    Director /MI
                                </div>
                            </div>

                            <div class="details mt-3">
                                <div class="flex justify-content-center bold mb-1">Certificate-2</div>
                                <div class="header my-3 mx-2 text-justify">It is certified that the farmer share of each
                                    applications has been tallied with the bank account passbook and application wise amount has been credited
                                    in the Farmer share bank account of MICADA.
                                </div>
                                <div class="flex justify-content-end mx-5 mt-5 pt-5">
                                    CAO / Accounts Officer
                                </div>
                            </div>

                            <div class="details mt-3">
                                <div class="flex justify-content-center bold mb-1 pt-5">Certificate-3</div>
                                <div class="header my-3 mx-2 text-justify">The <b>{{ miCertificateData?.totalLotApp }}</b> no. of cases for Rs. <b>{{ miCertificateData?.prevDate }}</b> is
                                    submitted for approval and payment to <b>{{ miCertificateData?.NoOfVendors == null ? '___' : miCertificateData?.NoOfVendors }}</b> no. of vendors as per details of lot <b>{{ lotNo }}</b>
                                </div>
                                <div class="flex justify-content-end mx-5 mt-5">
                                    CAO
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="flex justify-content-around mt-5">
                        <button pButton pRipple icon="pi pi-print" type="submit" label="{{'PRINT'| translate}}"
                            (click)="onPrint('printableArea')"></button>
                    </div>  -->
                </p-card>
            </div>


            <div class="card">
                <h5><b>{{'TOTAL_NO_OF_APPLICATIONS_FILTERED_FOR_MI_FARMER_SHARE' | translate}} {{'VIEW_APPLICATION' |
                        translate}}: {{ miSurveyData?.length }}</b>
                </h5>
                <!-- <div class="p-fluid p-formgrid grid">
                    <div class="field col-12 md:col-4">
                        <p>Total Subsidy To Farmer Amount: {{ totalSubToFarmer }}</p>
                    </div>
                    <div class="field col-12 md:col-4">
                        <p>Total Subsidy To Vendor Amount: {{ totalSubToVendor }}</p>
                    </div>
                    <div class="field col-12 md:col-4">
                        <p>Total Farmer Refund Amount: {{ totalFarmerRefund }}</p>
                    </div>
                </div> -->
                <div class="flex justify-content-end">
                    <button (click)="menu.toggle($event)" pButton pRipple p-button-info
                        label="{{'DOWNLOAD_FILTERED_LOT_DATA' | translate}}" icon="pi pi-upload"></button>
                    <p-menu #menu [popup]="true" [model]="appVerificationItems"
                        styleClass="prime-slider-override"></p-menu>
                </div>

                <!-- <div class="card">
                    <p-toolbar *ngIf="filteredData.length">
                        <ng-template pTemplate="left">

                        </ng-template>
                        <ng-template pTemplate="right">
                            <p-dropdown [options]="items" [(ngModel)]="selectedStatus" optionLabel="status"
                                class="mr-3">
                            </p-dropdown>
                            <textarea id="description" [(ngModel)]="remarks" placeholder="Remarks" pInputTextarea
                                required rows="3" cols="20" class="mr-3"></textarea>
                            <button pButton pRipple label="Submit" (click)="handleClick()"
                                class="p-button-help"></button>
                        </ng-template>
                    </p-toolbar>
                </div> -->
            </div>

        </p-card>
    </div>
</p-dialog>